const mockTest2 = [
 {
  question: "Steam locomotive me boiler ka mukhya karya kya hai?",
  options: ["Steam banana", "Brake lagana", "Coach chalana", "Signal dena"],
  answer: "Steam banana",
},
{
  question: "Indian Railways me Broad Gauge ki width kitni hoti hai?",
  options: ["1676 mm", "1435 mm", "1000 mm", "762 mm"],
  answer: "1676 mm",
},
{
  question: "ICF Coach ka full form kya hai?",
  options: [
    "Integral Coach Factory",
    "Indian Coach Frame",
    "Internal Coach Factory",
    "Integrated Coach Formation"
  ],
  answer: "Integral Coach Factory",
},
{
  question: "WAP-7 locomotive kis type ki locomotive hai?",
  options: ["Electric", "Diesel", "Steam", "Hybrid"],
  answer: "Electric",
},
{
  question: "Wheel flange ka mukhya kaam kya hota hai?",
  options: [
    "Wheel ko track par guide karna",
    "Speed badhana",
    "Brake lagana",
    "Fuel bachana"
  ],
  answer: "Wheel ko track par guide karna",
},
{
  question: "Rail fracture ka pata lagane ke liye kis technique ka use hota hai?",
  options: [
    "Ultrasonic Testing",
    "X-Ray",
    "Laser Cutting",
    "Welding"
  ],
  answer: "Ultrasonic Testing",
},
{
  question: "Air Brake system me compressor ka kaam kya hai?",
  options: [
    "Compressed air banana",
    "Oil supply karna",
    "Fuel supply karna",
    "Cooling karna"
  ],
  answer: "Compressed air banana",
},
{
  question: "LHB coach me primary suspension me kya use hota hai?",
  options: [
    "Coil Spring",
    "Leaf Spring",
    "Rubber Pad",
    "Air Bag"
  ],
  answer: "Coil Spring",
},
{
  question: "Diesel engine me piston kis motion me chalta hai?",
  options: [
    "Reciprocating Motion",
    "Rotary Motion",
    "Oscillating Motion",
    "Circular Motion"
  ],
  answer: "Reciprocating Motion",
},
{
  question: "Indian Railways ka sabse bada zone kaunsa hai?",
  options: [
    "Northern Railway",
    "Western Railway",
    "Central Railway",
    "Southern Railway"
  ],
  answer: "Northern Railway",
}, 
{
  question: "Rail wheel ka material aam taur par kya hota hai?",
  options: ["Cast Steel", "Aluminium", "Copper", "Brass"],
  answer: "Cast Steel",
},
{
  question: "WDM-3A kis prakaar ka locomotive hai?",
  options: ["Diesel", "Electric", "Steam", "Battery"],
  answer: "Diesel",
},
{
  question: "LHB coach me braking system kaunsa hota hai?",
  options: ["Air Brake", "Vacuum Brake", "Hydraulic Brake", "Mechanical Brake"],
  answer: "Air Brake",
},
{
  question: "Indian Railways me 'EMU' ka full form kya hai?",
  options: [
    "Electric Multiple Unit",
    "Engine Main Unit",
    "Electric Motor Utility",
    "Express Multiple Unit"
  ],
  answer: "Electric Multiple Unit",
},
{
  question: "Coach bogie ka mukhya kaam kya hai?",
  options: [
    "Coach ko support aur stability dena",
    "Engine start karna",
    "Brake oil store karna",
    "Signal dena"
  ],
  answer: "Coach ko support aur stability dena",
},
{
  question: "Rail track ka standard rail length (BG) aam taur par kitni hoti hai?",
  options: ["13 m", "26 m", "40 m", "52 m"],
  answer: "13 m",
},
{
  question: "WAP ka matlab kya hai?",
  options: [
    "Wide Gauge AC Passenger",
    "Water Air Pressure",
    "Wheel Axle Power",
    "Western AC Passenger"
  ],
  answer: "Wide Gauge AC Passenger",
},
{
  question: "Diesel locomotive me fuel kis tank me store hota hai?",
  options: ["Fuel Tank", "Air Tank", "Brake Tank", "Radiator"],
  answer: "Fuel Tank",
},
{
  question: "Railway signal ka green color kya batata hai?",
  options: ["Proceed", "Stop", "Caution", "Danger"],
  answer: "Proceed",
},
{
  question: "Indian Railways ka sabse tez operational train kaunsi hai?",
  options: ["Vande Bharat Express", "Rajdhani Express", "Shatabdi Express", "Duronto Express"],
  answer: "Vande Bharat Express",
},
{
  question: "Railway track me sleeper ka mukhya kaam kya hota hai?",
  options: [
    "Rail ko support dena",
    "Train ko power dena",
    "Signal control karna",
    "Brake lagana"
  ],
  answer: "Rail ko support dena",
},
{
  question: "Indian Railways me 'CBC' ka full form kya hai?",
  options: [
    "Centre Buffer Coupler",
    "Central Brake Controller",
    "Coach Brake Connector",
    "Central Bogie Coupler"
  ],
  answer: "Centre Buffer Coupler",
},
{
  question: "Diesel engine me lubrication system ka mukhya kaam kya hai?",
  options: [
    "Friction kam karna",
    "Fuel badhana",
    "Speed control karna",
    "Air pressure banana"
  ],
  answer: "Friction kam karna",
},
{
  question: "LHB Coach ki maximum design speed kitni hoti hai?",
  options: [
    "160 km/h",
    "110 km/h",
    "130 km/h",
    "90 km/h"
  ],
  answer: "160 km/h",
},
{
  question: "Railway wheel tread ka mukhya kaam kya hota hai?",
  options: [
    "Rail par smooth rolling",
    "Brake oil store karna",
    "Signal receive karna",
    "Engine cool karna"
  ],
  answer: "Rail par smooth rolling",
},
{
  question: "Railway turnout ka mukhya kaam kya hota hai?",
  options: [
    "Train ko ek track se dusre track par le jana",
    "Train rokna",
    "Speed badhana",
    "Coach jodna"
  ],
  answer: "Train ko ek track se dusre track par le jana",
},
{
  question: "Bogie frame kis material ka bana hota hai?",
  options: ["Fabricated Steel", "Plastic", "Aluminium Sheet", "Copper"],
  answer: "Fabricated Steel",
},
{
  question: "Indian Railways me 'POH' ka full form kya hai?",
  options: [
    "Periodic Over Hauling",
    "Power Over Head",
    "Passenger Operation Halt",
    "Platform Over Head"
  ],
  answer: "Periodic Over Hauling",
},
{
  question: "Coach wheel ka profile kisliye maintain kiya jata hai?",
  options: [
    "Safe running ke liye",
    "Colour ke liye",
    "Weight badhane ke liye",
    "Brake oil ke liye"
  ],
  answer: "Safe running ke liye",
},
{
  question: "Hot axle ka matlab kya hota hai?",
  options: [
    "Bearing ka adhik garam ho jana",
    "Engine garam hona",
    "Rail garam hona",
    "Brake fail hona"
  ],
  answer: "Bearing ka adhik garam ho jana",
},
{
  question: "UIC ka full form kya hai?",
  options: [
    "International Union of Railways",
    "United Indian Coaches",
    "Universal Inspection Committee",
    "Union of Indian Coaches"
  ],
  answer: "International Union of Railways",
},
{
  question: "Primary suspension kis ke beech hoti hai?",
  options: [
    "Axle Box aur Bogie Frame",
    "Coach Body aur Roof",
    "Wheel aur Rail",
    "Engine aur Coach"
  ],
  answer: "Axle Box aur Bogie Frame",
},
{
  question: "Secondary suspension kis ke beech hoti hai?",
  options: [
    "Bogie Frame aur Coach Body",
    "Wheel aur Rail",
    "Brake aur Wheel",
    "Axle aur Wheel"
  ],
  answer: "Bogie Frame aur Coach Body",
},
{
  question: "Railway me CBC ka mukhya fayda kya hai?",
  options: [
    "Safety aur high speed operation",
    "Fuel bachana",
    "Horn bajana",
    "Coach paint karna"
  ],
  answer: "Safety aur high speed operation",
},
{
  question: "LHB coach me FIAT bogie kis desh ki design hai?",
  options: [
    "Italy",
    "Germany",
    "India",
    "Japan"
  ],
  answer: "Italy",
},
{
  question: "Railway me tamping machine ka mukhya kaam kya hota hai?",
  options: [
    "Ballast packing",
    "Rail cutting",
    "Coach washing",
    "Track painting"
  ],
  answer: "Ballast packing",
},
{
  question: "LHB coach body kis material ki bani hoti hai?",
  options: [
    "Stainless Steel",
    "Cast Iron",
    "Copper",
    "Aluminium"
  ],
  answer: "Stainless Steel",
},
{
  question: "Brake cylinder kis system ka part hai?",
  options: [
    "Air Brake System",
    "Cooling System",
    "Fuel System",
    "Lubrication System"
  ],
  answer: "Air Brake System",
},
{
  question: "Wheel slip hone ka mukhya karan kya hai?",
  options: [
    "Adhesion kam hona",
    "Engine oil badhna",
    "Brake shoe tootna",
    "Horn kharab hona"
  ],
  answer: "Adhesion kam hona",
},
{
  question: "Coach suspension ka mukhya uddeshya kya hai?",
  options: [
    "Ride comfort aur stability",
    "Fuel bachana",
    "Horn control",
    "Signal dena"
  ],
  answer: "Ride comfort aur stability",
},
{
  question: "Indian Railways me Vande Bharat kis prakaar ki train hai?",
  options: [
    "Semi High Speed EMU",
    "Metro",
    "Freight",
    "Steam"
  ],
  answer: "Semi High Speed EMU",
},
{
  question: "Axle box ka mukhya kaam kya hai?",
  options: [
    "Bearing ko support dena",
    "Fuel store karna",
    "Brake oil rakhna",
    "Signal control"
  ],
  answer: "Bearing ko support dena",
},
{
  question: "Wheel balancing ka fayda kya hai?",
  options: [
    "Vibration kam hota hai",
    "Fuel badhta hai",
    "Coach bhaari hota hai",
    "Rail garam hoti hai"
  ],
  answer: "Vibration kam hota hai",
},
{
  question: "Indian Railways me inspection car ka prayog kisliye hota hai?",
  options: [
    "Track inspection",
    "Passenger service",
    "Parcel loading",
    "Fuel transport"
  ],
  answer: "Track inspection",
},
{
  question: "BG ka full form kya hai?",
  options: [
    "Broad Gauge",
    "Big Gear",
    "Brake Gauge",
    "Bridge Gauge"
  ],
  answer: "Broad Gauge",
},
{
  question: "Loco pilot ki mukhya zimmedari kya hoti hai?",
  options: [
    "Train safely chalana",
    "Ticket check karna",
    "Platform saaf karna",
    "Coach paint karna"
  ],
  answer: "Train safely chalana",
},
{
  question: "Bearing overheating ko rokne ke liye kya zaroori hai?",
  options: [
    "Proper lubrication",
    "Extra horn",
    "Painting",
    "Brake block badalna"
  ],
  answer: "Proper lubrication",
},
{
  question: "Indian Railways ka pehla route kis do shahron ke beech tha?",
  options: [
    "Mumbai–Thane",
    "Delhi–Agra",
    "Kolkata–Howrah",
    "Chennai–Bengaluru"
  ],
  answer: "Mumbai–Thane",
},
{
  question: "Wheel diameter ghisne par kya karna chahiye?",
  options: [
    "Reprofiling ya replacement",
    "Paint karna",
    "Grease lagana",
    "Horn badalna"
  ],
  answer: "Reprofiling ya replacement",
},
{
  question: "Railway coach me emergency window ka uddeshya kya hai?",
  options: [
    "Emergency evacuation",
    "Ventilation",
    "Decoration",
    "Lighting"
  ],
  answer: "Emergency evacuation",
},

];

export default mockTest2;